(function () {
  /**
   * @ngdoc module
   * @name binky.core.trusts
   * @description module that defines trusts
   */
  angular.module('binky.core.trusts', ['binky.core.common.list', 'binky.core.lodash']);
})();
